//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drafting.js";
import "../no/Builder.js";
import "../Drafting/Drafting.CutCopyPasteLeaderBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[1,"CutCopyPasteLeader",0,"Drafting.CutCopyPasteLeaderBuilder",0],[0,"DestinationView",1,"View",0],[1,"ObjectsToCopy",0,"SelectTaggedObjectList",0],[0,"Originals",1,0],[1,"OutputObjects",0,"SelectTaggedObjectList",0],[0,"PasteType",1,0],[0,"PlaneToRestrictMotion",1,"Plane",0],[1,"Transform",0,"GeometricUtilities.ModlMotion",0]],[[[],"GetDefaultToPoint",{R_:{dropLocation:''}},0,0],[["dropLocation"],"SetDefaultToPoint",{},1,0],[["rot","trans"],"SetMoveOnCommit",{},2,0],[[],"InitPaste",{},0,0]],[]];
SPLM.Drafting.CutCopyPasteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drafting.CutCopyPasteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drafting.CutCopyPasteBuilder.TypePaste = Object.freeze({
    "Transform" : "Transform", "Tracking" : "Tracking"});

SPLM.Drafting.CutCopyPasteBuilder.TypeOperation = Object.freeze({
    "Copy" : "Copy", "Cut" : "Cut"});

export default SPLM;